//src/layouts/auth/ForgotPassword.js
import { useState } from "react";
import { forgotPassword } from "../../services/authService";

export default function ForgotPassword() {
    // 📌 State lưu email mà người dùng nhập vào
    const [email, setEmail] = useState("");

    // 📌 State lưu thông báo thành công (sau khi gửi yêu cầu)
    const [message, setMessage] = useState("");

    // 📌 State lưu thông báo lỗi (nếu gửi yêu cầu thất bại)
    const [error, setError] = useState("");

    const [isSubmitting, setIsSubmitting] = useState(false);

    // 📌 Xử lý khi submit form
    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setMessage("");
        setIsSubmitting(true);
        try {
            const res = await forgotPassword(email);
            setMessage(res.message);
        } catch (err) {
            setError(err.response?.data?.message || "Có lỗi xảy ra");
        }
        finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="max-w-md mx-auto p-4">
            <h2 className="text-2xl font-bold mb-4">Quên mật khẩu</h2>
            {message && <div className="text-green-500">{message}</div>}
            {error && <div className="text-red-500">{error}</div>}
            <form onSubmit={handleSubmit} className="space-y-4">
                <input
                    type="email"
                    placeholder="Nhập email của bạn"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    className="w-full p-2 border rounded"
                />
                <button
                    type="submit"
                    disabled={isSubmitting} 
                    className={`w-full text-white py-2 rounded 
                        ${isSubmitting ? "bg-gray-400" : "bg-blue-600 hover:bg-blue-700"}`}
                >
                    {isSubmitting ? "Đang gửi..." : "Gửi email đặt lại mật khẩu"}
                </button>
            </form>
        </div>
    );
}
